module.exports = __webpack_public_path__ + "static/media/Iconfield06.f9c0213e.svg";